import script from "./ServerCommandsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerCommandsTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerCommandsTab.vue?vue&type=style&index=0&id=bc7b4c78&lang=scss"

const __exports__ = script;

export default __exports__